import { route, subGroup, meta } from '@/helpers/routes'

import DashboardProfessional from './gadget/index'
// :cnpj/:crm/:uf

const routes = [
  route('index', ':cnpj/:crm/:uf', DashboardProfessional, meta('Perfil profissional pessoa jurídica', true, 'guest'))
]

export default subGroup('/', routes)



// WEBPACK FOOTER //
// ./src/app/patient/profile-company-professional/routes.js